import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_CARRIER_MASTER: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 100,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'carrierId',
    label: 'Carrier ID',
    width: 200,
    type: 'number',
  },
  { dataKey: 'carrierName', label: 'Carrier Name', width: 200, type: 'text' },
  {
    dataKey: 'description',
    label: 'Description',
    width: 300,
    type: 'text',
  },
];

export const TABLE_CONFIG_COLUMNS_CARRIER_MAPPING: DyTableColumn[] = [
  {
    dataKey: 'carrierFromPMS',
    label: 'Carrier From PMS',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'carrierMaster',
    label: 'Carrier Master',
    width: 500,
    type: 'dropdown',
    dropdownValues: [
      {
        name: 'Delta Dental',
        value: '1',
      },
      {
        name: 'Cigna',
        value: '2',
      },
      {
        name: 'MetLife',
        value: '3',
      },
      {
        name: 'Anthem',
        value: '4',
      },
    ],
  },
  {
    dataKey: '',
    label: '',
    width: 300,
    type: 'text',
  },
];

export const TABLE_CONFIG_CARRIER_PLAN_MASTER_FORM_DETAILS: DyTableColumn[] = [
  {
    dataKey: 'carrierPlanId',
    label: 'Carrier Plan ID',
    width: 200,
    type: 'number',
  },
  {
    dataKey: 'carrierPlanName',
    label: 'Carrier Plan Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'description',
    label: 'Description',
    width: 300,
    type: 'text',
  },
  {
    dataKey: 'carrierName',
    label: 'Carrier Name',
    width: 200,
    type: 'text',
  },
];


export const TABLE_CONFIG_COLUMNS_CARRIER_PLAN: DyTableColumn[] = [
  {
    dataKey: 'id',
    label: 'Carrier Plan ID',
    width: 150,
    type: 'text',
  },
  { dataKey: 'carrierPlanName', label: 'Carrier Plan Name', width: 100, type: 'text' },
  {
    dataKey: 'description',
    label: 'Carrier Description',
    width: 150,
    type: 'text',
  }
];

export const TABLE_CONFIG_COLUMNS_PRACTICE_CARRIER_MASTER: DyTableColumn[] = [
  {
    dataKey: 'id',
    label: 'Carrier ID',
    width: 150,
    type: 'text',
  },
  { dataKey: 'carrierName', label: 'Carrier Name', width: 100, type: 'text' },
  {
    dataKey: 'carrierDescription',
    label: 'Description',
    width: 150,
    type: 'text',
  }
];


